import { OverridesStyleRules } from '@mui/material/styles/overrides';

import { tableContainerInterpolation } from '../interpolations/table-container.interpolation';

export const tableContainerOverrides:
  | Partial<OverridesStyleRules<'root', 'MuiTableContainer'>>
  | undefined = {
  root: tableContainerInterpolation,
};
